/* global $:true dataLayer:true */
/**
 * Youtube List Block
 *
 *
 */

import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '.g-ytsubscribe';
const MODULE_NAME = 'app.core/modules/youtube-list-block';
const log = debug(MODULE_NAME);
const ZERO = 0;
const SCRIPT = '<script src="https://apis.google.com/js/platform.js"></script>';

class YoutubeListBlock {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$scriptContainer = $(this.options.scriptContainer);

        log('YoutubeListBlock', element);

        this.loadScript();

        log('ready', this.$element);
    }

    loadScript () {
        if (typeof(this.$scriptContainer) !== 'undefined') {
            if (this.$scriptContainer.find('script').length == 0) {
                this.$scriptContainer.html(SCRIPT);
            }
        }
    }
}

YoutubeListBlock.DEFAULTS = {
    scriptContainer: '.youtube-list-block-scripts'
};

plugin('youtubeListBlock', YoutubeListBlock);

export function exec () {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).youtubeListBlock();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/youtube-list-block/index.js